import { DefaultRequest } from 'scripts/api';

class GenericFormRouter extends App.Routers.BaseRouter {
    constructor(routePrefix, tabName) {
        super(routePrefix);

        this.routePrefix = routePrefix;
        this.tabName = tabName;
    }

    makeForm = (userInterface, userInterfaceAction) => {
        const { tabName, routePrefix } = this;

        if (this.tabName) {
            this.tabControl(tabName, routePrefix, userInterface, userInterfaceAction);
        } else {
            this.tabControl(tabName, routePrefix);
        }
        this.getFormLayout(routePrefix,
            userInterface,
            userInterfaceAction,
            this.generateForm,
            this.beforeCreateForm,
            this.afterCreateForm,
            tabName
        );
    }

    generateForm = (routePrefix, userInterface, userInterfaceAction, data, beforeCreateForm, afterCreateForm, tabName) => {
        var baseRouter = new App.Routers.BaseRouter();
        var tabSelector = '';

        if (beforeCreateForm) {
            beforeCreateForm(userInterface, userInterfaceAction, data);
        }

        if (!tabName) {
            tabSelector = routePrefix + userInterface;
        } else {
            tabSelector = tabName;
        }

        baseRouter.renderMonetForm(tabName, data, tabSelector);

        if (afterCreateForm) {
            afterCreateForm(userInterface, userInterfaceAction, data);
        }
    }

    getFormLayout = (routePrefix, userInterface, userInterfaceAction, getFormCallback, beforeCreate, afterCreate, tabName) => {
        if (userInterface && userInterfaceAction) {
            const request = new DefaultRequest({
                url: 'form/' + userInterface + '/' + userInterfaceAction,
                success: (data) => {
                    if (Object.keys(data).length > 0 && getFormCallback) {
                        getFormCallback(routePrefix, userInterface,
                            userInterfaceAction, data, beforeCreate,
                            afterCreate, tabName);
                    }
                }
            });
            request.send();
        } else {
            this.generateEmptyForm();
        }
    }

    generateEmptyForm = () => {
        if (this.beforeCreateForm) {
            this.beforeCreateForm();
        }

        if (this.afterCreateForm) {
            this.afterCreateForm();
        }
    }

    tabControl = (tabName, routePrefix, userInterface) => {
        const tabForm = document.querySelector(`#${tabName} #form_and_grid`);
        const container = document.querySelector(`#${routePrefix}${userInterface}`) || (!tabForm && document.getElementById(tabName));

        if (container) {
            container.innerHTML = '<div class="span10 form_and_grid_generic" id="form_and_grid"></div>';
        }
    }
}

App.Routers.GenericForm = GenericFormRouter;
